const MOCK_CSC_CENTERS = [
  {
    id: 'csc-001',
    centerName: 'Rajesh Kumar Seva Kendra',
    ownerName: 'Rajesh Kumar',
    address: '45 Main Market, Sector 7',
    city: 'Hisar',
    state: 'Haryana',
    pincode: '125001',
    mobile: '9876543210',
    email: 'rajesh.csc@gmail.com',
    rating: 4.5,
    totalReviews: 128,
    serviceCharges: {
      'New Aadhaar Card Enrolment': 50,
      'Aadhaar Update and Correction': 50,
      'New PAN Card Application (NSDL)': 80,
      'Driving Licence Learner Licence Application': 150,
      'Voter ID Card New Registration (Form 6)': 30,
      'Fresh Passport Application Normal Scheme': 200,
      'SSC CGL 2025 Combined Graduate Level': 100,
      'SSC CHSL 2025 LDC JSA Postal Assistant': 100,
      'HSSC Group D Recruitment 2025': 80,
      'IBPS PO Recruitment 2025 Probationary Officer': 120,
      'SBI PO Recruitment 2025': 120,
      'JEE Main 2025 Engineering Entrance Exam': 100,
      'NEET UG 2025 Medical Entrance Examination': 100,
      'Ayushman Bharat PM-JAY Golden Card Registration': 30,
      'PM Kisan Samman Nidhi New Farmer Registration': 50,
      'Haryana Kanyadan Yojana Marriage Assistance 2025': 0,
      'NSP Post Matric Scholarship 2025-26': 50,
      'PM Kaushal Vikas Yojana 4.0 Enrolment': 0,
      'MGNREGA Job Card Application 2025': 0,
      'SSC MTS Multi Tasking Staff Recruitment 2026': 100,
      'IBPS CRP Clerk XVI Recruitment 2026': 110,
      'Income Tax Return Filing ITR-1 Salaried 2026-27': 200,
      'Aadhaar Card New Enrolment 2026': 50,
      'RRB ALP and Technician Recruitment 2026': 100,
      'HSSC CGL Combined Graduate Level Recruitment 2026': 90,
    },
  },
  {
    id: 'csc-002',
    centerName: 'Sunita Devi Digital Seva Center',
    ownerName: 'Sunita Devi',
    address: 'Near Govt Hospital, Old Rohtak Road',
    city: 'Rohtak',
    state: 'Haryana',
    pincode: '124001',
    mobile: '9812345678',
    email: 'sunita.digitalseva@gmail.com',
    rating: 4.2,
    totalReviews: 87,
    serviceCharges: {
      'New Aadhaar Card Enrolment': 50,
      'Aadhaar Update and Correction': 50,
      'New PAN Card Application (NSDL)': 90,
      'Voter ID Card New Registration (Form 6)': 30,
      'HSSC Group D Recruitment 2025': 75,
      'SSC CGL 2025 Combined Graduate Level': 110,
      'SBI PO Recruitment 2025': 130,
      'PM Kisan Samman Nidhi Registration 2025': 50,
      'Kisan Credit Card Application 2025': 80,
      'PM Fasal Bima Yojana Crop Insurance 2025': 0,
      'MGNREGA Job Card Application 2025': 0,
      'PM Ujjwala Yojana 2.0 Free LPG Connection': 0,
      'PM Matru Vandana Yojana PMMVY Registration': 0,
      'Ayushman Bharat PM-JAY Golden Card Registration': 30,
      'PM Jeevan Jyoti Bima Yojana Enrolment': 50,
      'PMAY Gramin Rural Housing Application 2025': 0,
      'Haryana Kanyadan Yojana Marriage Assistance 2025': 0,
      'SSC MTS Multi Tasking Staff Recruitment 2026': 100,
      'NEET UG 2026 Medical Entrance Exam Application': 100,
      'IBPS CRP Clerk XVI Recruitment 2026': 120,
      'Income Tax Return Filing ITR-1 Salaried 2026-27': 220,
      'Aadhaar Card New Enrolment 2026': 50,
      'RRB ALP and Technician Recruitment 2026': 100,
      'HSSC CGL Combined Graduate Level Recruitment 2026': 80,
    },
  },
  {
    id: 'csc-003',
    centerName: 'Ram Lal Jan Sewa Kendra',
    ownerName: 'Ram Lal Sharma',
    address: 'Shop No. 12, Sindhi Camp Bus Stand',
    city: 'Jaipur',
    state: 'Rajasthan',
    pincode: '302001',
    mobile: '9414567890',
    email: 'ramlal.jansewa@gmail.com',
    rating: 4.7,
    totalReviews: 215,
    serviceCharges: {
      'New Aadhaar Card Enrolment': 50,
      'Aadhaar Update and Correction': 50,
      'New PAN Card Application (NSDL)': 85,
      'Driving Licence Learner Licence Application': 160,
      'Voter ID Card New Registration (Form 6)': 30,
      'Fresh Passport Application Normal Scheme': 250,
      'Tatkal Passport Application Urgent Scheme': 300,
      'Rajasthan Police Sub Inspector Recruitment 2025': 90,
      'SSC CGL 2025 Combined Graduate Level': 100,
      'SSC CHSL 2025 LDC JSA Postal Assistant': 100,
      'IBPS PO Recruitment 2025 Probationary Officer': 120,
      'IBPS RRB Officer Scale I Recruitment 2025': 120,
      'JEE Main 2025 Engineering Entrance Exam': 100,
      'NEET UG 2025 Medical Entrance Examination': 100,
      'CUET UG 2025 Central University Entrance Test': 80,
      'PM Kisan Samman Nidhi New Farmer Registration': 50,
      'NSP Post Matric Scholarship 2025-26': 50,
      'Kisan Credit Card Application 2025': 80,
      'Income Tax Return Filing ITR-1 Salaried 2025-26': 200,
      'SSC MTS Multi Tasking Staff Recruitment 2026': 100,
      'NEET UG 2026 Medical Entrance Exam Application': 110,
      'IBPS CRP Clerk XVI Recruitment 2026': 120,
      'Income Tax Return Filing ITR-1 Salaried 2026-27': 220,
      'Aadhaar Card New Enrolment 2026': 50,
      'RRB ALP and Technician Recruitment 2026': 100,
      'Rajasthan Police Sub Inspector Recruitment 2026': 90,
    },
  },
  {
    id: 'csc-004',
    centerName: 'Priya Online Seva Kendra',
    ownerName: 'Priya Sharma',
    address: '78 Clock Tower Market',
    city: 'Jodhpur',
    state: 'Rajasthan',
    pincode: '342001',
    mobile: '9928765432',
    email: 'priya.sevajodhpur@gmail.com',
    rating: 4.0,
    totalReviews: 63,
    serviceCharges: {
      'New Aadhaar Card Enrolment': 50,
      'Aadhaar Update and Correction': 60,
      'New PAN Card Application (NSDL)': 90,
      'Voter ID Card New Registration (Form 6)': 30,
      'Rajasthan Police Sub Inspector Recruitment 2025': 100,
      'JEE Main 2025 Engineering Entrance Exam': 110,
      'NEET UG 2025 Medical Entrance Examination': 110,
      'CUET UG 2025 Central University Entrance Test': 90,
      'PMAY Gramin Rural Housing Application 2025': 0,
      'Income Tax Return Filing ITR-1 Salaried 2025-26': 250,
      'PM Kisan Samman Nidhi New Farmer Registration': 50,
      'NSP Post Matric Scholarship 2025-26': 60,
      'PM Matru Vandana Yojana PMMVY Registration': 0,
      'UDID Unique Disability Identity Card Application': 0,
      'NEET UG 2026 Medical Entrance Exam Application': 120,
      'Income Tax Return Filing ITR-1 Salaried 2026-27': 250,
      'Aadhaar Card New Enrolment 2026': 50,
      'Rajasthan Police Sub Inspector Recruitment 2026': 100,
      'RRB ALP and Technician Recruitment 2026': 110,
    },
  },
  {
    id: 'csc-005',
    centerName: 'Suresh Gupta Digital Seva Point',
    ownerName: 'Suresh Gupta',
    address: 'Near Railway Station, Hazratganj',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    pincode: '226001',
    mobile: '9839123456',
    email: 'suresh.sevalko@gmail.com',
    rating: 4.3,
    totalReviews: 176,
    serviceCharges: {
      'New Aadhaar Card Enrolment': 50,
      'Aadhaar Update and Correction': 50,
      'New PAN Card Application (NSDL)': 85,
      'Driving Licence Learner Licence Application': 150,
      'Voter ID Card New Registration (Form 6)': 30,
      'Fresh Passport Application Normal Scheme': 220,
      'UP Police Constable Recruitment 2025': 90,
      'UPSC Civil Services Preliminary Exam 2025': 100,
      'SSC CGL 2025 Combined Graduate Level': 100,
      'IBPS PO Recruitment 2025 Probationary Officer': 120,
      'RRB NTPC Graduate Level Exam 2025': 100,
      'JEE Main 2025 Engineering Entrance Exam': 100,
      'NEET UG 2025 Medical Entrance Examination': 100,
      'PM Kisan Samman Nidhi New Farmer Registration': 50,
      'MGNREGA Job Card Application 2025': 0,
      'Ayushman Bharat PM-JAY Golden Card Registration': 30,
      'NSP Post Matric Scholarship 2025-26': 50,
      'SSC MTS Multi Tasking Staff Recruitment 2026': 100,
      'NEET UG 2026 Medical Entrance Exam Application': 100,
      'IBPS CRP Clerk XVI Recruitment 2026': 120,
      'UP Police Constable Recruitment 2026': 90,
      'Income Tax Return Filing ITR-1 Salaried 2026-27': 200,
      'Aadhaar Card New Enrolment 2026': 50,
      'RRB ALP and Technician Recruitment 2026': 100,
    },
  },
  {
    id: 'csc-006',
    centerName: 'Deepak Singh Multi Services Center',
    ownerName: 'Deepak Singh',
    address: 'Plot 22, Laxmi Nagar Market',
    city: 'New Delhi',
    state: 'Delhi',
    pincode: '110092',
    mobile: '9810987654',
    email: 'deepak.multiservices@gmail.com',
    rating: 4.6,
    totalReviews: 302,
    serviceCharges: {
      'New Aadhaar Card Enrolment': 50,
      'Aadhaar Update and Correction': 50,
      'New PAN Card Application (NSDL)': 80,
      'Driving Licence Learner Licence Application': 140,
      'Voter ID Card New Registration (Form 6)': 30,
      'Fresh Passport Application Normal Scheme': 200,
      'Tatkal Passport Application Urgent Scheme': 280,
      'Delhi e-Ration Card Application': 0,
      'SSC CGL 2025 Combined Graduate Level': 100,
      'SSC CHSL 2025 LDC JSA Postal Assistant': 100,
      'SBI PO Recruitment 2025': 120,
      'UPSC Civil Services Preliminary Exam 2025': 100,
      'RBI Grade B Officer Direct Recruitment 2025': 150,
      'LIC AAO Assistant Administrative Officer 2025': 130,
      'JEE Main 2025 Engineering Entrance Exam': 100,
      'Ayushman Bharat PM-JAY Golden Card Registration': 30,
      'Pradhan Mantri Jan Dhan Yojana Account Opening': 0,
      'Income Tax Return Filing ITR-1 Salaried 2025-26': 200,
      'UDID Unique Disability Identity Card Application': 0,
      'PM Jeevan Jyoti Bima Yojana Enrolment': 50,
      'SSC MTS Multi Tasking Staff Recruitment 2026': 100,
      'NEET UG 2026 Medical Entrance Exam Application': 100,
      'IBPS CRP Clerk XVI Recruitment 2026': 110,
      'Income Tax Return Filing ITR-1 Salaried 2026-27': 200,
      'Aadhaar Card New Enrolment 2026': 50,
      'RRB ALP and Technician Recruitment 2026': 100,
    },
  },
  {
    id: 'csc-007',
    centerName: 'Harpreet Singh Sewa Kendra',
    ownerName: 'Harpreet Singh',
    address: 'Golden Temple Road, Katra Jaimal Singh',
    city: 'Amritsar',
    state: 'Punjab',
    pincode: '143001',
    mobile: '9814234567',
    email: 'harpreet.sewakendra@gmail.com',
    rating: 4.4,
    totalReviews: 141,
    serviceCharges: {
      'New Aadhaar Card Enrolment': 50,
      'Aadhaar Update and Correction': 50,
      'New PAN Card Application (NSDL)': 85,
      'Driving Licence Learner Licence Application': 150,
      'Voter ID Card New Registration (Form 6)': 30,
      'Fresh Passport Application Normal Scheme': 200,
      'Punjab Ashirwad Scheme Old Age Pension': 0,
      'SSC CGL 2025 Combined Graduate Level': 100,
      'IBPS PO Recruitment 2025 Probationary Officer': 120,
      'IBPS RRB Officer Scale I Recruitment 2025': 120,
      'JEE Main 2025 Engineering Entrance Exam': 100,
      'NEET UG 2025 Medical Entrance Examination': 100,
      'PM Kisan Samman Nidhi New Farmer Registration': 50,
      'Kisan Credit Card Application 2025': 80,
      'PM Fasal Bima Yojana Crop Insurance 2025': 0,
      'PM Kaushal Vikas Yojana 4.0 Enrolment': 0,
      'NSP Post Matric Scholarship 2025-26': 50,
      'Pradhan Mantri Jan Dhan Yojana Account Opening': 0,
      'SSC MTS Multi Tasking Staff Recruitment 2026': 100,
      'NEET UG 2026 Medical Entrance Exam Application': 100,
      'IBPS CRP Clerk XVI Recruitment 2026': 120,
      'Income Tax Return Filing ITR-1 Salaried 2026-27': 200,
      'Aadhaar Card New Enrolment 2026': 50,
      'RRB ALP and Technician Recruitment 2026': 100,
    },
  },
  {
    id: 'csc-008',
    centerName: 'Abhay Kumar Jan Sewa Kendra',
    ownerName: 'Abhay Kumar',
    address: 'Near Patna Junction, Station Road',
    city: 'Patna',
    state: 'Bihar',
    pincode: '800001',
    mobile: '9798123456',
    email: 'abhay.jansewa@gmail.com',
    rating: 4.1,
    totalReviews: 94,
    serviceCharges: {
      'New Aadhaar Card Enrolment': 50,
      'Aadhaar Update and Correction': 50,
      'New PAN Card Application (NSDL)': 85,
      'Voter ID Card New Registration (Form 6)': 30,
      'Bihar Police Constable Recruitment 2025': 90,
      'BPSC 70th Combined Competitive Examination 2025': 100,
      'Bihar Mukhyamantri Vridha Pension Yojana 2025': 0,
      'SSC CGL 2025 Combined Graduate Level': 100,
      'RRB NTPC Graduate Level Exam 2025': 100,
      'Agniveer Army Bharti 2025': 80,
      'CRPF Constable Technical and Tradesman 2025': 80,
      'PM Kisan Samman Nidhi New Farmer Registration': 50,
      'MGNREGA Job Card Application 2025': 0,
      'NSP Post Matric Scholarship 2025-26': 50,
      'Ayushman Bharat PM-JAY Golden Card Registration': 30,
      'PM Ujjwala Yojana 2.0 Free LPG Connection': 0,
      'PMAY Gramin Rural Housing Application 2025': 0,
      'SSC MTS Multi Tasking Staff Recruitment 2026': 100,
      'IBPS CRP Clerk XVI Recruitment 2026': 120,
      'UP Police Constable Recruitment 2026': 90,
      'Income Tax Return Filing ITR-1 Salaried 2026-27': 200,
      'Aadhaar Card New Enrolment 2026': 50,
      'RRB ALP and Technician Recruitment 2026': 100,
      'Bihar Police Sub Inspector Recruitment 2026': 100,
    },
  },
  {
    id: 'csc-009',
    centerName: 'Meera Devi Digital Seva Kendra',
    ownerName: 'Meera Devi Sharma',
    address: 'Shop 4, New Market, Hamidia Road',
    city: 'Bhopal',
    state: 'Madhya Pradesh',
    pincode: '462001',
    mobile: '9425112233',
    email: 'meera.digitalseva.bpl@gmail.com',
    rating: 4.2,
    totalReviews: 108,
    serviceCharges: {},
  },
  {
    id: 'csc-010',
    centerName: 'Ganesh Prasad Jan Seva Kendra',
    ownerName: 'Ganesh Prasad Patil',
    address: '12 Dadar West, Near Shivaji Park',
    city: 'Mumbai',
    state: 'Maharashtra',
    pincode: '400028',
    mobile: '9819334455',
    email: 'ganesh.janseva.mum@gmail.com',
    rating: 4.3,
    totalReviews: 192,
    serviceCharges: {},
  },
  {
    id: 'csc-011',
    centerName: 'Krishnamurthy Online Seva Point',
    ownerName: 'Krishnamurthy R',
    address: '56 MG Road, Shivajinagar',
    city: 'Bengaluru',
    state: 'Karnataka',
    pincode: '560001',
    mobile: '9886556677',
    email: 'krishna.seva.blr@gmail.com',
    rating: 4.5,
    totalReviews: 237,
    serviceCharges: {},
  },
  {
    id: 'csc-012',
    centerName: 'Selvi Devi Digital Service Center',
    ownerName: 'Selvi Devi K',
    address: '18 Anna Salai, Triplicane',
    city: 'Chennai',
    state: 'Tamil Nadu',
    pincode: '600005',
    mobile: '9884778899',
    email: 'selvi.digitalsvc.chn@gmail.com',
    rating: 4.4,
    totalReviews: 163,
    serviceCharges: {},
  },
  {
    id: 'csc-013',
    centerName: 'Bhupen Das Seva Kendra',
    ownerName: 'Bhupen Das',
    address: 'Fancy Bazar, Chatribari Road',
    city: 'Guwahati',
    state: 'Assam',
    pincode: '781001',
    mobile: '9435990011',
    email: 'bhupen.sevakendra.gwh@gmail.com',
    rating: 4,
    totalReviews: 72,
    serviceCharges: {},
  },
  {
    id: 'csc-014',
    centerName: 'Santosh Kumar Sewa Kendra',
    ownerName: 'Santosh Kumar Mahto',
    address: 'Near Albert Ekka Chowk, Main Road',
    city: 'Ranchi',
    state: 'Jharkhand',
    pincode: '834001',
    mobile: '9334221133',
    email: 'santosh.sewa.ranchi@gmail.com',
    rating: 4.1,
    totalReviews: 85,
    serviceCharges: {},
  },
  {
    id: 'csc-015',
    centerName: 'Sasmita Pradhan Jan Seva Point',
    ownerName: 'Sasmita Pradhan',
    address: 'Unit 9, Vani Vihar Square',
    city: 'Bhubaneswar',
    state: 'Odisha',
    pincode: '751022',
    mobile: '9437556677',
    email: 'sasmita.seva.bbsr@gmail.com',
    rating: 4.2,
    totalReviews: 98,
    serviceCharges: {},
  },
  {
    id: 'csc-016',
    centerName: 'Ramesh Patel Digital Sewa Kendra',
    ownerName: 'Ramesh Patel',
    address: 'Law Garden, Ellisbridge',
    city: 'Ahmedabad',
    state: 'Gujarat',
    pincode: '380006',
    mobile: '9825334455',
    email: 'ramesh.patel.seva.ahm@gmail.com',
    rating: 4.3,
    totalReviews: 144,
    serviceCharges: {},
  },
  {
    id: 'csc-017',
    centerName: 'Sreekumar Nair Jan Seva Kendra',
    ownerName: 'Sreekumar Nair',
    address: 'MG Road, Ernakulam South',
    city: 'Kochi',
    state: 'Kerala',
    pincode: '682016',
    mobile: '9447112233',
    email: 'sreekumar.seva.kochi@gmail.com',
    rating: 4.6,
    totalReviews: 211,
    serviceCharges: {},
  },
];

export default MOCK_CSC_CENTERS;
